var exports = {
  "k": "xe7b6e3d6--2f616c--container",
  "v": "xe7b6e3d6--2f616c--tabs",
};

module.exports = exports;
